import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSpc } from '../context/SpcContext';
import { Megaphone } from 'lucide-react';

export default function BreakingNews() {
  const { user, state, markBreakingNewsSeen, breakingNewsMediaUrl } = useSpc();
  const [dismissedId, setDismissedId] = React.useState(null);
  const news = state?.breakingNewsPopup;

  const shouldShow = !!user && user.approvalStatus === 'approved' && user.hasSeenWelcome !== false
    && !!news && news.id !== dismissedId;

  const dismiss = () => {
    setDismissedId(news.id);
    markBreakingNewsSeen(news.id);
  };

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          className="welcome-backdrop"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          data-testid="breaking-news-modal"
        >
          <motion.div
            className="welcome-card breaking-news-card"
            initial={{ scale: 0.85, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 220, damping: 22 }}
          >
            <div className="welcome-body">
              <div className="welcome-icon breaking-news-icon"><Megaphone size={38} /></div>
              <span className="pill yellow" style={{ margin: '0 auto 10px' }}>SPC BREAKING NEWS</span>
              <h2 data-testid="breaking-news-title">{news.title}</h2>
              {news.mediaType === 'photo' && (
                <img src={breakingNewsMediaUrl()} alt="" style={{ width: '100%', borderRadius: 14, margin: '10px 0' }} data-testid="breaking-news-photo" />
              )}
              {news.mediaType === 'video' && (
                <video src={breakingNewsMediaUrl()} controls autoPlay muted playsInline style={{ width: '100%', borderRadius: 14, margin: '10px 0' }} data-testid="breaking-news-video" />
              )}
              <p data-testid="breaking-news-body">{news.body}</p>
            </div>
            <div className="welcome-actions">
              <button className="btn" onClick={dismiss} data-testid="breaking-news-dismiss">Got it 👊</button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
